import { TransactionDetails, TransactionRejectResponse } from 'models';
import { httpService } from 'services/httpService';

class TransactionService {
  transactionDetails(transactionId: string) {
    return httpService.get<TransactionDetails>(`/Transaction/Detail/${transactionId}`);
  }

  rejectTransaction(transactionId: string) {
    return httpService.post<TransactionRejectResponse>(`/Transaction/Reject/${transactionId}`);
  }
}

export const transactionService = new TransactionService();
